import * as types from "../types";
import { updateObject } from "../helpers/utils";
import { getToken, getOperator, setOperator } from './../../config/storageData';

const accountState = {
	token: getToken(),
	operator: getOperator(),
	authError: false,
	sessionExpirationSnackbarOpen: false,
	sessionExpirationTime: 0
};

export default function (state = accountState, action) {
	switch (action.type) {
		case types.LOGOUT: {
			return updateObject(state, {
				token: null
			})
		}
		case types.AUTH_FAILED: {
			return updateObject(state, {
				token: null,
				authError: true
			});
		}
		case types.AUTH_SUCCEEDED: {
			const { token, operator } = action;

			return updateObject(state, {
				token: token,
				operator: operator,
			});
		}
		case types.SET_OPERATOR_NAME: {
			setOperator(action.value);
			return {
				...state,
				operator: action.value
			};
		}
		case types.OPEN_SESSION_EXPIRATION_SNACKBAR:
			return {
				...state,
				sessionExpirationSnackbarOpen: action.open,
				sessionExpirationTime: action.value
			}
		default:
			return state;
	}
}
